export default "__VITE_ASSET__BbLslxi$__"